module.exports = __webpack_public_path__ + "img/xianfenshenghuoBanner.1ed5dbbd.png";